export default {
  ShowTransfer: 'ShowTransfer',
  ShowCAReceipt: 'ShowCAReceipt',
  Save: 'Save',
  SaveAdd: 'SaveAdd',
  SaveClose: 'SaveClose',
  //Hoãn
  Postpone: 'Postpone',
  NextVoucher: 'NextVoucher',
  BackVoucher: 'BackVoucher',
  SaveView: 'SaveView',
  Ok: 'OK',
  Delete: 'Delete',
  All: 'All',
  Follow: 'Follow',
  Unfollow: 'Unfollow',
  Active: 'Active',
  Unactive: 'Unactive',
  Edit: 'Edit',
  Duplicate: 'Duplicate',
  Add: 'Add',
  View: 'View',
  Posted: 'Posted',
  UnPosted: 'UnPosted',
  Estimate: 'Estimate',
  NextStep: 'NextStep',
  BackStep: 'BackStep',
  ViewAccount: 'ViewAccount',
  AddAutoBusiness: 'AddAutoBusiness',
  GenerateData: 'GenerateData',
  ApproveAction: 'ApproveAction',
  Refresh: 'Refresh',
  ChangeStatusPosted: 'ChangeStatusPosted',
  Copy: 'Copy',
  ShowWithDrawCash: 'ShowWithDrawCash',
  ShowWithDrawDeposit: 'ShowWithDrawDeposit',
  ShowWithDrawTransfer: 'ShowWithDrawTransfer',
  ShowWithDrawSalaryTransfer: 'ShowWithDrawSalaryTransfer',
  ShowBUTreasuryFundTransferSalary: 'ShowBUTreasuryFundTransferSalary',
  ShowBUTreasuryFundTransferInsurancePayment:'ShowBUTreasuryFundTransferInsurancePayment',
  GLVoucherDetail: 'GLVoucherDetail',
  SaveParalell: 'SaveParalell'
};
